import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import searcher from "../../assets/searchInput.svg";
import { useDispatch } from "react-redux";
import TableContainer from "../layouts/table-container/table-container";
import ErrorPopup from "../popups/ErrorPopup";
import ChangeSaved from "../popups/ChangeSaved";
import CloseIcon from "../../assets/icons/closeIcon";
import "../modals/bulk-upload/bulk-upload.css";
import { AdminButton } from "../buttons/versionHistoryBtn";
import {
  fetchAddDoctorList,
  productAddDoctorsRequest,
} from "../../redux/actions/productActions";
import LoadingSpinnerTable from "../utilites/loader";

const AddDoctorTableModal = ({ show, ShowClose, offerId, doctorListOpen }) => {
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [filterDoctorArray, setfilterDoctorArray] = useState([]);
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  useEffect(() => {
    if (show) {
      setloading(true);
      dispatch(fetchAddDoctorList(onDoctorSuccess, onDoctorError));
    }
  }, [show]);

  const onDoctorSuccess = (data) => {
    setDoctorsList(data.data.data);
    setfilterDoctorArray(data.data.data);
    setloading(false);
  };
  const onDoctorError = (err) => {
    setloading(false);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const checkedProduct = (e, item) => {
    const { checked } = e.target;

    setProductVerifiedList((prevList) => {
      if (checked) {
        return [
          ...prevList,
          {
            doctor_id: item.id,
          },
        ];
      } else {
        return prevList.filter((obj) => obj.doctor_id !== item.id);
      }
    });
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
    doctorListOpen();
  };

  const searchHandler = (e) => {
    console.log(e.target.value == "");

    if (e.target.value === "") {
      setfilterDoctorArray(doctorsList);
    } else {
      let newArr = doctorsList.filter(
        (doctor) =>
          doctor.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
          doctor.code.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setfilterDoctorArray(newArr);
    }
  };

  const doctorsOffersSubmit = () => {
    const formattedDoctors = {
      doctors: productVerifiedList.map((doctor) => doctor.doctor_id),
    };
    dispatch(
      productAddDoctorsRequest(
        { offer_id: offerId, ...formattedDoctors },
        onDoctorOfferSuccess,
        onDoctorOfferError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    doctorListOpen();
  };

  const onDoctorOfferSuccess = (data) => {
    ShowClose();
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
    setProductVerifiedList([]);
  };
  const onDoctorOfferError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="add-doctor-data-table-container col-12 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <span className="fn_Nunito fw_700 fs_22">ADD DOCTOR</span>
            <button
              className="border-0 bg-white"
              onClick={() => {
                ShowClose();
                doctorListOpen();
                setProductVerifiedList([]);
              }}
            >
              <CloseIcon fill="black" width={"14px"} />
            </button>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container">
            <div className="search-container d-flex justify-content-between w-100">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search Doctor here by Doctor Name and Code..."
                  onChange={searchHandler}
                />
              </div>
            </div>
            <div style={{ maxHeight: "50vh", overflow: "auto" }}>
              <TableContainer>
                <thead>
                  <tr className="table-rows color_747f9e">
                    <th className="table-heads " width={"2%"}></th>
                    <th className="table-heads " width={"5%"}>
                      Doctor Code
                    </th>
                    <th className="table-heads " width={"12%"}>
                      Doctor Name
                    </th>
                  </tr>
                </thead>
                <tbody style={{ position: "relative" }}>
                  {loading === true ? (
                    <div className="list-spinner-container">
                      <LoadingSpinnerTable />
                    </div>
                  ) : (
                    <>
                      {filterDoctorArray?.map((item, index) => (
                        <tr className="table-rows1" key={index}>
                          <td className="table-each-row-data" width={"3%"}>
                            <input
                              type="checkbox"
                              className="superCheck"
                              id={`checkbox-${index}`}
                              name="prodcutsCheck"
                              onChange={(e) => checkedProduct(e, item)} // Pass individual item
                              checked={productVerifiedList.some(
                                (obj) => obj.doctor_id === item.id
                              )}
                            />
                          </td>
                          <td className="table-each-row-data">{item.code}</td>
                          <td className="table-each-row-data">{item.name}</td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </TableContainer>
            </div>
          </div>
          <div className="my-2 mt-4">
            {productVerifiedList.length > 0 && (
              <div className="d-flex gap-4 justify-content-end">
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="180px"
                  onClick={doctorsOffersSubmit}
                >
                  <span className="m-2 fw_700">Confirm</span>
                </AdminButton>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default AddDoctorTableModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
